import type { RouteRecordRaw } from 'vue-router'

export const SURVEYS = 'surveys'
export const SURVEY_DETAILS = 'survey-details'
export const BSCL_DETAILS = 'bscl-details'
export const EPISODES_OF_CARE = 'episodes-of-care'
export const EPISODE_OF_CARE_DETAILS = 'episode-of-care-details'
export default [
  {
    path: '/episodes-of-care/:eocId/surveys/:surveyId',
    name: SURVEY_DETAILS,
    component: () => import('./views/TreatmentList.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/episodes-of-care/:eocId/bscl/:bsclId',
    name: BSCL_DETAILS,
    component: () => import('./views/TreatmentList.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/episodes-of-care/:eocId',
    name: EPISODE_OF_CARE_DETAILS,
    component: () => import('./views/TreatmentList.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/episodes-of-care',
    name: EPISODES_OF_CARE,
    component: () => import('./views/TreatmentList.vue'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/surveys',
    name: SURVEYS,
    component: () => import('./views/TreatmentList.vue'),
    meta: {
      auth: true,
    },
  },
] as RouteRecordRaw[]
